import React from 'react';
import { trans } from '@spotahome/soyuz/client';

import DamageProtectIcon from '@components/icons/DamageProtectIcon';
import CancellationProtectIcon from '@components/icons/CancellationProtectIcon';
import TotallyOnlineIcon from '@components/icons/TotallyOnlineIcon';
import SectionOverlay from '@components/SectionOverlay';

import TextBlock from '@components/TextBlock';
import FeatureBoxList from '@components/FeatureBoxList';

import './LandlordGuaranteeSection.scss';

const featureList = [
  {
    icon: <CancellationProtectIcon />,
    description: 'landlord.landing.guarantee.fair-policies'
  },
  {
    icon: <DamageProtectIcon />,
    description: 'landlord.landing.guarantee.security'
  },
  {
    icon: <TotallyOnlineIcon />,
    description: 'landlord.landing.guarantee.online-renting'
  }
];

const LandlordGuaranteeSection = () => (
  <section className="landlord-guarantee-section">
    <SectionOverlay>
      <TextBlock
        title={trans('landlord.landing.landlord-guarantee.title')}
        titleSize="big"
        titleTag="h2"
      />
      <FeatureBoxList featureList={featureList} />
    </SectionOverlay>
  </section>
);

export default LandlordGuaranteeSection;
